import React from 'react';
import PropTypes from 'prop-types';
import { startCase } from 'lodash';
import Svg from 'rp-react-svg-icon';
import classNames from 'classnames';
import Popover from '../../Popover';
import Abbr from '../../Abbr';
import PopoverLink from './PopoverLink';

// Popover component has state: { expanded } and
// change state.expanded to false on outside click
class MoreBtn extends Popover {
    render() {
        const { url, hash, tabNames, currentTab, is5Tabs } = this.props;
        const { expanded } = this.state;
        const activeTab = tabNames.find(tabName => tabName === currentTab);
        const isFirstSelected = activeTab === tabNames[0];
        const className = classNames(
            'ui-tabs__tab', 'pp-tabs__tab', 'pp-tabs__more', 'hidden-md-up',
            expanded && 'ui-tabs__tab_more_major',
            activeTab && 'ui-tabs__tab_selected',
            isFirstSelected && 'pp-tabs__more_firstSelected',
            is5Tabs && 'pp-tabs__more_fiveTabs'
        );

        /* eslint jsx-a11y/no-static-element-interactions: 0 */
        return (
            <div className={className} onClick={this.togglePopover}>
                <div className={'ui-tabs__tab_more'}>
                    {isFirstSelected ? (
                        <Abbr title="More">{startCase(activeTab)}</Abbr>
                    ) : (
                        startCase(activeTab) || 'More'
                    )}
                    <span className="ui-tabs__arrow">
                        <Svg iconName="down" />
                    </span>
                </div>
                {expanded &&
                    <div className="ui-popover ui-popover_customised">
                        {tabNames.map((tabName, i) => (
                            <PopoverLink
                                key={tabName}
                                tabName={tabName}
                                url={url}
                                hash={hash}
                                className={i === 0 ? 'hidden-sm-up' : ''}
                            />
                        ))}
                    </div>
                }
            </div>
        );
    }
}

MoreBtn.propTypes = {
    url: PropTypes.string.isRequired,
    hash: PropTypes.string,
    currentTab: PropTypes.string,
    is5Tabs: PropTypes.bool.isRequired,
    tabNames: PropTypes.arrayOf(PropTypes.string),
};

export default MoreBtn;



// WEBPACK FOOTER //
// ./src/js/shared/nav/components/MoreBtn.jsx